import PropTypes from "prop-types";
import React, { Component } from "react";
import theme from "styles/theme";

const styles = {
    base: {
        margin: `${theme.spacing.desktopGutter}px 0`,
        height: "1px",
        backgroundColor: theme.palette.lightGrey,
    },
};

class Separator extends Component {
    static propTypes = {
        style: PropTypes.object,
    };

    render() {
        return <div style={Object.assign({}, styles.base, this.props.style)} />;
    }
}

export default Separator;
